import schedulerViewMode from 'utils/enums/scheduler-view-mode.enum'

const initialState = {
	loading: false,
	pageHeaderText: '',
	alert: null,
	currentDialogToggle: false,
	unreadAlertAmount: 0,
	reportsGranularity: 'hour',
	schedulerSettings: {
		view: 'week',
		currentDate: new Date(),
		contactCenter: {
			value: 'all',
			label: 'Select All',
		},
		selectedUser: null,
		viewMode: schedulerViewMode.CALENDAR,
	},
	tablesState: {
		marketingEventLogNotifications: {
			searchQuery: '',
			sortBy: [{
				id: 'sentAt',
				desc: true,
			}],
			dateRangeFilter: {
				name: 'sentAt',
				displayName: 'Sent',
				from: null,
				to: null,
			},
			page: 0,
		},
		pushNotifications: {
			searchQuery: '',
			sortBy: [{
				id: 'sentAt',
				desc: true,
			}],
			dateRangeFilter: {
				name: 'sentAt',
				displayName: 'Sent',
				from: null,
				to: null,
			},
			page: 0,
		},
		contactCenters: {
			searchQuery: '',
			sortBy: [{
				id: 'name',
				desc: false,
			}],
			page: 0,
		},
		appointmentList: {
			searchQuery: '',
			sortBy: [{
				id: 'callCenterName',
				desc: false,
			}],
			page: 0,
			dateRangeFilter: {
				name: 'startTime',
				displayName: 'Date',
				from: null,
				to: null,
			},
		},
		users: {
			searchQuery: '',
			sortBy: [{
				id: 'fullName',
				desc: false,
			}],
			page: 0,
		},
		customerRegistrations: {
			sortBy: [{
				id: 'name',
				desc: false,
			}],
			page: 0,
		},
	},
	isExpandedSidebar: true,
};

const commonReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'USER_LOGOUT':
			return initialState;
		case 'SET_LOADING':
			return {
				...state,
				loading: action.payload.value,
			};
		case 'SET_ALERT':
			return {
				...state,
				alert: action.payload.value
			};
		case 'SET_PAGE_HEADER_TEXT':
			return {
				...state,
				pageHeaderText: action.payload.value
			};
		case 'TOGGLE_CURRENT_DIALOG':
			return {
				...state,
				currentDialogToggle: !state.currentDialogToggle,
			};
		case 'SET_TABLE_STATE':
			return {
				...state,
				tablesState: {
					...state.tablesState,
					[action.payload.value.table]: action.payload.value.state
				}
			};
		case 'SET_UNREAD_ALERT_AMOUNT':
			return {
				...state,
				unreadAlertAmount: action.payload.value,
			};
		case 'SET_REPORTS_GRANULARITY':
			return {
				...state,
				reportsGranularity: action.payload.value,
			};
		case 'SET_SCHEDULER_SETTING':
			return {
				...state,
				schedulerSettings: {
					...state.schedulerSettings,
					[action.payload.name]: action.payload.value,
				},
			};
		case 'SET_EXPANDED_SIDEBAR':
			return {
				...state,
				isExpandedSidebar: action.payload,
			};
		default:
			return state;
	}
};

export const setLoadingActionCreator = value => ({
	type: 'SET_LOADING',
	payload: {
		value
	}
});

export const setAlertActionCreator = value => ({
	type: 'SET_ALERT',
	payload: {
		value
	}
});

export const setPageHeaderTextActionCreator = value => ({
	type: 'SET_PAGE_HEADER_TEXT',
	payload: {
		value
	}
});

export const rerenderCurrentDialogActionCreator = () => ({
	type: 'TOGGLE_CURRENT_DIALOG',
	payload: {},
});

export const setTableStateActionCreator = value => ({
	type: 'SET_TABLE_STATE',
	payload: {
		value
	}
});

export const setUnreadAlertAmountActionCreator = value => ({
	type: 'SET_UNREAD_ALERT_AMOUNT',
	payload: {
		value,
	},
});

export const setReportsGranularityActionCreator = (value = 'hour') => ({
	type: 'SET_REPORTS_GRANULARITY',
	payload: {
		value,
	},
});

export const setSchedulerSettingActionCreator = (name, value) => ({
	type: 'SET_SCHEDULER_SETTING',
	payload: {
		name,
		value,
	},
});

export const setExpandSidebarActionCreator = (payload) => ({
	type: 'SET_EXPANDED_SIDEBAR',
	payload,
});

export default commonReducer;
